import fetch from "../utils/fetch";
export function confirmOrCancelParticipate(params) {
  return fetch({
    method: 'POST',
    url: '/collageGroup/confirmOrCancelParticipate',
    data:params
  })
}
export function getCollageGroupList(params) {
  return fetch({
    method: 'POST',
    url: '/collageGroup/getCollageGroupList',
    data:params
  })
}